import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Select from 'react-select';

function EditableFlagBadge({ value, options, label, tooltip, onSave, disabled }) {
  const [editing, setEditing] = useState(false);

  if (disabled) {
    return (
      <OverlayTrigger placement="top" overlay={<Tooltip>{tooltip}</Tooltip>}>
        <Badge variant="success">
          {label} - {value || '-'}
        </Badge>
      </OverlayTrigger>
    );
  }

  if (editing) {
    return (
      <Select
        autoFocus
        isClearable
        menuIsOpen
        options={options}
        value={options.find(op => op.value === value) || null}
        onChange={option => {
          onSave(option?.value ?? null);
          setEditing(false);
        }}
        onBlur={() => setEditing(false)}
      />
    );
  }

  return (
    <OverlayTrigger placement="top" overlay={<Tooltip>{tooltip}</Tooltip>}>
      <Badge variant="success" style={{ cursor: 'pointer' }} onClick={() => setEditing(true)}>
        {label} - {value || '-'}
      </Badge>
    </OverlayTrigger>
  );
}

EditableFlagBadge.propTypes = {
  value: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    }),
  ).isRequired,
  label: PropTypes.string.isRequired,
  tooltip: PropTypes.string.isRequired,
  onSave: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default EditableFlagBadge;
